export default __webpack_public_path__ + "static/media/activate.f12177bf.svg";